import React, { useState, useEffect } from "react";

import Create_icon from "../../../assets/images/create_icon.png";
import { NotificationManager } from "react-notifications";
import AdminToolsDataService from "../../../services/admin-tools.service";
import { useTranslation } from "react-i18next";
import Edit_icon from "../../../assets/images/icons/edit_icon.svg";
import Delete_iconbl from "../../../assets/images/icons/delete_iconbl.svg";
import { useSelector } from "react-redux";
import { Button, Checkbox, Modal, Select, Spin, Switch, Table, Tooltip } from "antd";


const initialNewPermission = {
  id: 0,
  pageNumber: "",
  firstTierPageName: "",
  secondTierPageName: "",
  thirdTierPageName: "",
  fourTierPageName: "",
  vendorSuperSwitch: true,
  vendorAdminSwitch: true,
  vendorUserSwitch: true,
  vendorDiamondSuperSwitch: true,
  VendorDiamondAdminSwitch: true,
  VendorDiamondUserSwitch: true,
  vendorGemstoneSuperSwitch: true,
  VendorGemstoneAdminSwitch: true,
  VendorGemstoneUserSwitch: true,
  retailerAdminSwitch: true,
  retailerSuperSwitch: true,
  retailerUserSwitch: true,
  adminAdminSwitch: true,
  adminSuperSwitch: true,
  adminUserSwitch: true,
  combinerAdminSwitch: true,
  combinerSuperSwitch: true,
  combinerUserSwitch: true,
  organizationSuperSwitch: true,
};
const initialValidations = {
  pageNumberVal: "",
  firstTierPageNameVal: "",
  secondTierPageNameVal: "",
  thirdTierPageNameVal: "",
  fourTierPageNameVal: "",
  allEmptyVal: "",
};

const Permissions = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [isedit, setIsEdit] = useState(true);
  const [PermissionData, setPermissionData] = useState([]);
  const [disableBtn, setDisableBtn] = useState(true);
  const [tierVisible, setTierVisible] = useState(false);
  const [newPermission, setNewPermission] = useState(initialNewPermission);
  const [validations, setValidations] = useState(initialValidations);
  const [filterVal, setFilterVal] = useState({
    tierOne: "Admin",
    tierTwo: "Tools",
  });
  const [tierOneList, setTierOneList] = useState([]);
  const [tierTwoList, setTierTwoList] = useState([]);
  const [visible3, setVisible3] = useState(false);

  const [delPermissionData, setDelPermissionData] = useState({
    id: "",
  });
  const [tierEntry, setTierEntry] = useState({
    tierPageNameType: "",
    firstTierDep: "",
    tierPageNameValue: "",
  });
  const [tiervalidations, setTierValidations] = useState({
    firstTierDepVal: "",
    tierPageNameTypeVal: "",
    tierPageNameValueVal: "",
  });
  const [dealerId, setDealerId] = useState();
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const loginDetials = useSelector((state) => state.loginReducer);

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
        }
      }
    }
    handleGetDynamicPageAccessDetailsList(pageNo, pageSize);
    handleGetTierDtlsByType();
    handleGetTierTwoDtlsByType(filterVal.tierOne);
  }, []);

  const { Option } = Select;

  const handleModalOpen = () => {
    setVisible(true);
    setIsEdit(false);
  };

  const handleModalTierOpen = () => {
    setTierVisible(true);
  };

  const handleModalTierCancel = () => {
    setTierVisible(false);
    setTierEntry({
      tierPageNameType: "",
      tierPageNameValue: "",
    });
    setTierValidations({
      tierPageNameTypeVal: "",
      tierPageNameValueVal: "",
    });
  };

  const handleTierSave = async () => {
    const isValid = handleTierValidation();
    if (!isValid) {
      return false;
    }
    try {
      let inputData = {
        id: 0,
        tierName: tierEntry.tierPageNameValue,
        firstTierName: tierEntry.firstTierDep ? tierEntry.firstTierDep : "",
        type: tierEntry.tierPageNameType,
        dealerID: dealerId,
      };
      setLoading(true);
      await AdminToolsDataService.AddUpdateTierData(inputData)
        .then((response) => {
          var message = response.data.message;
          var returnId = response.data.responseData.returnId;
          setLoading(false);
          if (message === "Success") {
            if (returnId == 1) {
              NotificationManager.success(t("Record Updated Successfully."));
              handleGetTierDtlsByType();
            } else if (returnId == 2) {
              NotificationManager.error(t("Record already Exists."));
            }
          } else {
            NotificationManager.error(t("Record Not Updated."));
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    handleModalTierCancel();
  };

  const handleInputChange = (e, isSelect, name) => {
    if (isSelect === "select") {
      setTierEntry({
        ...tierEntry,
        [name]: e,
      });
    } else {
      setTierEntry({
        ...tierEntry,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleTierValidation = () => {
    const tiervalidations = {
      tierPageNameTypeVal: "",
      tierPageNameValueVal: "",
      firstTierDepVal: "",
    };
    let isValid = true;
    if (!tierEntry.tierPageNameType) {
      isValid = false;
      tiervalidations.tierPageNameTypeVal = t("Tier Type is Compulsory");
    }
    if (!tierEntry.tierPageNameValue || tierEntry.tierPageNameValue !== "") {
      isValid = false;
      tiervalidations.tierPageNameValueVal = t("Tier Name is Compulsory");
    }
    if (tierEntry.tierPageNameType == "Second") {
      if (!tierEntry.firstTierDep) {
        isValid = false;
        tiervalidations.firstTierDepVal = t("First Tier Value is Compulsory");
      }
    }
    if (!isValid) {
      setTierValidations(tiervalidations);
    }
    return isValid;
  };

  const handleCancel = () => {
    setVisible(false);
    setIsEdit(true);
    setNewPermission(initialNewPermission);
    setValidations(initialValidations);
  };

  const handleOnChange = (e, isSelect, name) => {
    if (isSelect === "select") {
      setNewPermission({
        ...newPermission,
        [name]: e,
      });
    } else {
      setNewPermission({
        ...newPermission,
        [e.target.name]: e.target.value,
      });
      if (e.target.name === "pageNumber") {
        setValidations((prevdata) => ({
          ...prevdata,
          pageNumberVal: "",
        }));
      }
      if (e.target.name === "firstTierPageName") {
        setValidations((prevdata) => ({
          ...prevdata,
          firstTierPageNameVal: "",
        }));
      }
      if (e.target.name === "secondTierPageName") {
        setValidations((prevdata) => ({
          ...prevdata,
          secondTierPageNameVal: "",
        }));
      }
      if (e.target.name === "thirdTierPageName") {
        setValidations((prevdata) => ({
          ...prevdata,
          thirdTierPageNameVal: "",
        }));
      }
      if (e.target.name === "fourTierPageName") {
        setValidations((prevdata) => ({
          ...prevdata,
          fourTierPageNameVal: "",
        }));
      }
    }
  };

  const handleOnSelectChange = (e, isSelect, name) => {
    setDisableBtn(false);
    if (name === "tierOne") {
      handleGetTierTwoDtlsByType(e);
      setFilterVal({
        tierOne: e,
        tierTwo: "",
      });
    } else {
      if (isSelect === "select") {
        setFilterVal({
          ...filterVal,
          [name]: e,
        });
      } else {
        setFilterVal({
          ...filterVal,
          [e.target.name]: e.target.value,
        });
      }
    }
  };

  const handleGetTierDtlsByType = async () => {
    let inputData = {
      type: "one",
    };
    setLoading(true);
    await AdminToolsDataService.GetTierDtlsByType(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          setTierOneList(responseData);
        } else {
          setTierOneList([]);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDelCancel = () => {
    setVisible3(false);
    setDelPermissionData({
      id: "",
    });
  };

  const handleDeleteTierDetails = async () => {
    let inputData = {
      permisssionID: parseInt(delPermissionData.id),
    };
    setLoading(true);
    await AdminToolsDataService.DeleteTierDetails(inputData)
      .then((response) => {
        var message = response.data.message;
        if (message === "Success") {
          NotificationManager.success(t("Record Deleted Successfully"));
          handleGetDynamicPageAccessDetailsList(pageNo, pageSize);
          setVisible3(false);
        } else {
          NotificationManager.success(t("Record Not Deleted"));
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleGetTierTwoDtlsByType = async (id) => {
    let inputData = {
      type: "two",
      parentvalue: id,
    };
    setLoading(true);
    await AdminToolsDataService.GetTierDtlsByType(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          setTierTwoList(responseData);
        } else {
          setTierTwoList([]);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleValidation = () => {
    const {
      pageNumber,
      firstTierPageName,
      secondTierPageName,
      thirdTierPageName,
      fourTierPageName,
    } = newPermission;
    const validations = {
      pageNumberVal: "",
      firstTierPageNameVal: "",
      secondTierPageNameVal: "",
      thirdTierPageNameVal: "",
      fourTierPageNameVal: "",
      allEmptyVal: "",
    };
    let isValid = true;

    if (secondTierPageName !== "" || thirdTierPageName !== "") {
      if (!firstTierPageName.trim()) {
        isValid = false;
        validations.firstTierPageNameVal = t(
          "First Tier Page Name is compulsory"
        );
      }
    }

    if (thirdTierPageName !== "") {
      if (!secondTierPageName.trim()) {
        isValid = false;
        validations.secondTierPageNameVal = t(
          "Second Tier Page Name is compulsory"
        );
      }
    }

    if (
      pageNumber == "" &&
      firstTierPageName == "" &&
      secondTierPageName == "" &&
      thirdTierPageName == ""
    ) {
      isValid = false;
      validations.allEmptyVal = t("Selecting Any Field is compulsory");
    }

    if (!isValid) {
      setValidations(validations);
    }
    return isValid;
  };

  const handleGetDynamicPageAccessDetailsList = (pageNo, pageSize) => {
    let inputData = {
      oneTierPageName: filterVal.tierOne,
      twoTierPageName: filterVal.tierTwo,
    };
    setLoading(true);
    AdminToolsDataService.GetDynamicPageAccessDetailsList(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          setPermissionData(responseData);
          setDisableBtn(true);
          if (tableLoading) {
            setTableLoading(false);
          }
        } else {
          if (tableLoading) {
            setTableLoading(false);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        if (tableLoading) {
          setTableLoading(false);
        }
      })
      .finally(() => {
        setTableLoading(false);
        setLoading(false);
      });
  };

  const handleSubmit = async () => {
    if (!isedit) {
      const isValid = handleValidation();
      if (!isValid) {
        return false;
      }
    }
    try {
      let inputData = {
        id: parseInt(id),
        pageNumber: 0,
        oneTierPageName: firstTierPageName,
        twoTierPageName: secondTierPageName,
        threeTierPageName: thirdTierPageName,
        fourTierPageName: fourTierPageName,
        vendorSuper: vendorSuperSwitch,
        vendorAdmin: vendorAdminSwitch,
        vendorUser: vendorUserSwitch,
        retailerSuper: retailerSuperSwitch,
        retailerAdmin: retailerAdminSwitch,
        retailerUser: retailerUserSwitch,
        adminSuper: adminSuperSwitch,
        adminAdmin: adminAdminSwitch,
        adminUser: adminUserSwitch,
        vendorDiamondSuper: vendorDiamondSuperSwitch,
        vendorDiamondAdmin: VendorDiamondAdminSwitch,
        vendorDiamondUser: VendorDiamondUserSwitch,
        vendorGemstoneSuper: vendorGemstoneSuperSwitch,
        vendorGemstoneAdmin: VendorGemstoneAdminSwitch,
        vendorGemstoneUser: VendorGemstoneUserSwitch,
      };
      setLoading(true);
      await AdminToolsDataService.SaveDynamicPageAccessDetails(inputData)
        .then((response) => {
          setLoading(false);
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            NotificationManager.success(t("Permission Updated Successfully."));

            handleGetDynamicPageAccessDetailsList(pageNo, pageSize);
          } else {
            if ((responseData.returnId = 1)) {
              NotificationManager.error(t("Record Not Found"));
            } else {
              NotificationManager.error(t("Permission Not Updated."));
            }
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    handleCancel();
  };

  const {
    id,
    pageNumber,
    firstTierPageName,
    secondTierPageName,
    thirdTierPageName,
    fourTierPageName,
    vendorSuperSwitch,
    vendorAdminSwitch,
    vendorUserSwitch,
    vendorDiamondSuperSwitch,
    VendorDiamondAdminSwitch,
    VendorDiamondUserSwitch,
    vendorGemstoneSuperSwitch,
    VendorGemstoneAdminSwitch,
    VendorGemstoneUserSwitch,
    retailerAdminSwitch,
    retailerSuperSwitch,
    retailerUserSwitch,
    adminAdminSwitch,
    adminSuperSwitch,
    adminUserSwitch,
  } = newPermission;

  const {
    pageNumberVal,
    firstTierPageNameVal,
    secondTierPageNameVal,
    thirdTierPageNameVal,
    fourTierPageNameVal,
  } = validations;

  const handleEditModal = (row) => {
    setVisible(true);
    setNewPermission({
      id: row.id,
      pageNumber: row.pageNumber,
      firstTierPageName: row.oneTierPageName,
      secondTierPageName: row.twoTierPageName,
      thirdTierPageName: row.threeTierPageName,
      fourTierPageName: row.fourTierPageName,
      vendorSuperSwitch: row.vendorSuper,
      vendorAdminSwitch: row.vendorAdmin,
      vendorUserSwitch: row.vendorUser,
      vendorDiamondSuperSwitch: row.vendorDiamondSuper,
      VendorDiamondAdminSwitch: row.vendorDiamondAdmin,
      VendorDiamondUserSwitch: row.vendorDiamondUser,
      vendorGemstoneSuperSwitch: row.vendorGemstoneSuper,
      VendorGemstoneAdminSwitch: row.vendorGemstoneAdmin,
      VendorGemstoneUserSwitch: row.vendorGemstoneUser,
      retailerAdminSwitch: row.retailerAdmin,
      retailerSuperSwitch: row.retailerSuper,
      retailerUserSwitch: row.retailerUser,
      adminAdminSwitch: row.adminAdmin,
      adminSuperSwitch: row.adminSuper,
      adminUserSwitch: row.adminUser,
    });
  };

  const handleDeleteModal = (row) => {
    setVisible3(true);
    setDelPermissionData({
      id: row.id,
      dealerID: row.dealerID,
    });
  };

  const handleApplyFilters = () => {
    handleGetDynamicPageAccessDetailsList(pageNo, pageSize);
  };

  return (
    <React.Fragment>
      <div className="permission_section">
        <div className="form__fields">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-6">
                  <h4 className="workarea__heading mt-0 mb-0">
                    {t("Permissions")}
                  </h4>
                </div>
                <div className="col-lg-6">
                  <div className="add__btndiv d-flex justify-content-end">
                    <button
                      className="primary-btn d-flex align-items-center"
                      onClick={handleModalOpen}
                    >
                      {" "}
                      <img src={Create_icon} alt="" />
                      <span>{t("Add New")} </span>
                    </button>
                    <button
                      className="primary-btn ml-2 d-flex align-items-center"
                      onClick={handleModalTierOpen}
                    >
                      {" "}
                      <img src={Create_icon} alt="" />
                      <span>{t("Add New Tier")} </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="permission_tbldiv">
                <div className="row">
                  <div className="col-lg-4 col-md-6">
                    <div className="input__block">
                      <label>
                        {" "}
                        {t("Select 1 Tier PageName")}
                        <span className="mandatory">*</span>{" "}
                      </label>
                      <Select
                        value={filterVal.tierOne ? filterVal.tierOne : null}
                        name="tierOne"
                        onChange={(e) =>
                          handleOnSelectChange(e, "select", "tierOne")
                        }
                        placeholder={t("Select Type")}
                        showSearch
                        optionFilterProp="children"
                        className={"border__grey"}
                      >
                        <Option value=""> {t("Select Type")} </Option>

                        {tierOneList &&
                          tierOneList.map((item) => {
                            return (
                              <Option key={item?.id} value={item.id}>
                                {item.value}
                              </Option>
                            );
                          })}
                      </Select>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="input__block">
                      <label>
                        {" "}
                        {t("Select 2 Tier PageName")}
                        <span className="mandatory">*</span>{" "}
                      </label>
                      <Select
                        value={filterVal.tierTwo ? filterVal.tierTwo : null}
                        name="tierTwo"
                        onChange={(e) =>
                          handleOnSelectChange(e, "select", "tierTwo")
                        }
                        placeholder={t("Select Type")}
                        showSearch
                        optionFilterProp="children"
                        className={"border__grey"}
                      >
                        <Option value=""> {t("Select Type")} </Option>

                        {tierTwoList &&
                          tierTwoList.map((item) => {
                            return (
                              <Option key={item?.id} value={item.id}>
                                {item.value}
                              </Option>
                            );
                          })}
                      </Select>
                    </div>
                  </div>
                  <div className="col-md-4 aplyfilt__btndiv">
                    <button
                      className={
                        disableBtn
                          ? "disabled-btn mt-2rem mobile__bottomspace"
                          : "primary-btn mt-2rem mobile__bottomspace"
                      }
                      disabled={disableBtn}
                      onClick={() => handleApplyFilters()}
                    >
                      {" "}
                      <i className="fa fa-search"></i> {t("Apply Filter")}
                    </button>
                  </div>
                </div>
                <Spin
                  spinning={tableLoading ? tableLoading : loading}
                  size="large"
                >
                  <Table
                    columns={[
                      {
                        title: (
                          <Tooltip title={t("3 Tier PageName")}>
                            {t("3 Tier PageName")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "threeTierPageName",
                        Key: "threeTierPageName",
                        // fixed: "left",
                        render: (item, row) => {
                          return (
                            <div className="input__block">
                              <p className="font__bold">
                                {row.threeTierPageName}
                              </p>
                            </div>
                          );
                        },
                      },
                      {
                        title: (
                          <Tooltip title={t("Vendor Super")}>
                            {t("Vendor Super")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "vendorSuper",
                        Key: "vendorSuper",
                        render: (item, row) => {
                          return <Checkbox checked={row.vendorSuper} />;
                        },
                      },
                      {
                        title: (
                          <Tooltip title={t("Vendor Admin")}>
                            {t("Vendor Admin")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "vendorAdmin",
                        Key: "vendorAdmin",
                        render: (item, row) => {
                          return <Checkbox checked={row.vendorAdmin} />;
                        },
                      },
                      {
                        title: (
                          <Tooltip title={t("Vendor User")}>
                            {t("Vendor User")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "vendorUser",
                        Key: "vendorUser",
                        render: (item, row) => {
                          return <Checkbox checked={row.vendorUser} />;
                        },
                      },
                      {
                        title: (
                          <Tooltip title={t("Vendor-Diamond Super")}>
                            {t("Vendor-Diamond Super")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "vendorDiamondSuper",
                        Key: "vendorDiamondSuper",
                        render: (item, row) => {
                          return <Checkbox checked={row.vendorDiamondSuper} />;
                        },
                      },
                      {
                        title: (
                          <Tooltip title={t("Vendor-Diamond Admin")}>
                            {t("Vendor-Diamond Admin")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "vendorDiamondAdmin",
                        Key: "vendorDiamondAdmin",
                        render: (item, row) => {
                          return <Checkbox checked={row.vendorDiamondAdmin} />;
                        },
                      },
                      {
                        title: (
                          <Tooltip title={t("Vendor-Diamond User")}>
                            {t("Vendor-Diamond User")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "vendorDiamondUser",
                        Key: "vendorDiamondUser",
                        render: (item, row) => {
                          return <Checkbox checked={row.vendorDiamondUser} />;
                        },
                      },
                      {
                        title: (
                          <Tooltip title={t("Vendor-Gemstone Super")}>
                            {t("Vendor-Gemstone Super")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "vendorGemstoneSuper",
                        Key: "vendorGemstoneSuper",
                        render: (item, row) => {
                          return <Checkbox checked={row.vendorGemstoneSuper} />;
                        },
                      },
                      {
                        title: (
                          <Tooltip title={t("Vendor-Gemstone Admin")}>
                            {t("Vendor-Gemstone Admin")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "vendorGemstoneAdmin",
                        Key: "vendorGemstoneAdmin",
                        render: (item, row) => {
                          return <Checkbox checked={row.vendorGemstoneAdmin} />;
                        },
                      },
                      {
                        title: (
                          <Tooltip title={t("Vendor-Gemstone User")}>
                            {t("Vendor-Gemstone User")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "vendorGemstoneUser",
                        Key: "vendorGemstoneUser",
                        render: (item, row) => {
                          return <Checkbox checked={row.vendorGemstoneUser} />;
                        },
                      },
                      {
                        title: (
                          <Tooltip title={t("Retailer Super")}>
                            {t("Retailer Super")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "retailerSuper",
                        Key: "retailerSuper",
                        render: (item, row) => {
                          return <Checkbox checked={row.retailerSuper} />;
                        },
                      },
                      {
                        title: (
                          <Tooltip title={t("Retailer Admin")}>
                            {t("Retailer Admin")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "retailerAdmin",
                        Key: "retailerAdmin",
                        render: (item, row) => {
                          return <Checkbox checked={row.retailerAdmin} />;
                        },
                      },
                      {
                        title: (
                          <Tooltip title={t("Retailer User")}>
                            {t("Retailer User")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "retailerUser",
                        Key: "retailerUser",
                        render: (item, row) => {
                          return <Checkbox checked={row.retailerUser} />;
                        },
                      },
                      {
                        title: (
                          <Tooltip title={t("Admin Super")}>
                            {t("Admin Super")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "adminSuper",
                        Key: "adminSuper",
                        render: (item, row) => {
                          return <Checkbox checked={row.adminSuper} />;
                        },
                      },
                      {
                        title: (
                          <Tooltip title={t("Admin Admin")}>
                            {t("Admin Admin")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "adminAdmin",
                        Key: "adminAdmin",
                        render: (item, row) => {
                          return <Checkbox checked={row.adminAdmin} />;
                        },
                      },
                      {
                        title: (
                          <Tooltip title={t("Admin User")}>
                            {t("Admin User")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "adminUser",
                        Key: "adminUser",
                        render: (item, row) => {
                          return <Checkbox checked={row.adminUser} />;
                        },
                      },
                      {
                        title: (
                          <Tooltip title={t("Actions")}>{t("Actions")}</Tooltip>
                        ),
                        ellipsis: true,
                        dataIndex: "save",
                        render: (text, row) => (
                          <div className="action__btns">
                            <div className="image__block">
                              <img
                                src={Edit_icon}
                                onClick={() => {
                                  handleEditModal(row);
                                }}
                                alt=""
                              />
                            </div>
                            <div className="image__block">
                              <img
                                src={Delete_iconbl}
                                onClick={() => {
                                  handleDeleteModal(row);
                                }}
                                alt=""
                              />
                            </div>
                          </div>
                        ),
                      },
                    ]}
                    dataSource={PermissionData}
                    onChange={(pagination, filters, sorters) => {
                      document
                        .getElementsByClassName("content__area")[0]
                        .scroll(0, 0);
                    }}
                    pagination={{
                      size: "small",
                      pageSizeOptions: [10, 15, 20, 50, 100],
                      responsive: true,
                      showSizeChanger: true,
                    }}
                  />
                </Spin>
              </div>
            </div>

            <div className="col-lg-12">
              <Modal
                title={t("Permissions")}
                className="modal__permission"
                centered
                visible={visible}
                width={600}
                onCancel={handleCancel}
                footer={[
                  <Button key="back" onClick={handleCancel}>
                    {t("Cancel")}
                  </Button>,
                  <Button key="submit" type="primary" onClick={handleSubmit}>
                    {t("Submit")}
                  </Button>,
                ]}
              >
                {validations.allEmptyVal && (
                  <p className="error-color-red">{validations.allEmptyVal}</p>
                )}
                <div className="col-lg-12">
                  <div className="modal__body">
                    <div className="col-lg-12">
                      <div className="form__fields border-0 p-0">
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("Page Number")} :</label>
                              <input
                                type="int"
                                placeholder={t("Enter pageNumber")}
                                name="pageNumber"
                                value={pageNumber}
                                onChange={handleOnChange}
                                className={pageNumberVal && "border__red"}
                              />
                              <div>
                                {pageNumberVal && (
                                  <p className="error-color-red">
                                    {pageNumberVal}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("Select 1 Tier PageName")}</label>
                              <Select
                                value={
                                  firstTierPageName ? firstTierPageName : null
                                }
                                name="firstTierPageName"
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "firstTierPageName"
                                  )
                                }
                                placeholder={t("Select Type")}
                                showSearch
                                optionFilterProp="children"
                                className={
                                  firstTierPageNameVal
                                    ? "border__red"
                                    : "border__grey"
                                }
                              >
                                <Option value=""> {t("Select Type")} </Option>

                                {tierOneList &&
                                  tierOneList.map((item) => {
                                    return (
                                      <Option key={item?.id} value={item.id}>
                                        {item.value}
                                      </Option>
                                    );
                                  })}
                              </Select>

                              <div>
                                {firstTierPageNameVal && (
                                  <p className="error-color-red">
                                    {firstTierPageNameVal}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("Select 2 Tier PageName")}</label>
                              <Select
                                value={
                                  secondTierPageName ? secondTierPageName : null
                                }
                                name="secondTierPageName"
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "secondTierPageName"
                                  )
                                }
                                placeholder={t("Select Type")}
                                showSearch
                                optionFilterProp="children"
                                className={
                                  secondTierPageNameVal
                                    ? "border__red"
                                    : "border__grey"
                                }
                              >
                                <Option value=""> {t("Select Type")} </Option>

                                {tierTwoList &&
                                  tierTwoList.map((item) => {
                                    return (
                                      <Option key={item?.id} value={item.id}>
                                        {item.value}
                                      </Option>
                                    );
                                  })}
                              </Select>
                              <div>
                                {secondTierPageNameVal && (
                                  <p className="error-color-red">
                                    {secondTierPageNameVal}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("3 Tier PageName")}</label>
                              <input
                                type="text"
                                placeholder={t("Enter 3rd Tier PageName: ")}
                                name="thirdTierPageName"
                                value={thirdTierPageName}
                                onChange={handleOnChange}
                                className={
                                  thirdTierPageNameVal && "border__red"
                                }
                              />
                              <div>
                                {thirdTierPageNameVal && (
                                  <p className="error-color-red">
                                    {thirdTierPageNameVal}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("4 Tier PageName")}</label>
                              <input
                                type="text"
                                placeholder={t("Enter 4 Tier PageName")}
                                name="fourTierPageName"
                                value={fourTierPageName}
                                onChange={handleOnChange}
                                className={fourTierPageNameVal && "border__red"}
                              />
                              <div>
                                {fourTierPageNameVal && (
                                  <p className="error-color-red">
                                    {fourTierPageNameVal}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label>{t("Vendor Super")} :</label>
                              <Switch
                                name="vendorSuperSwitch"
                                checkedChildren={t("Yes")}
                                unCheckedChildren={t("No")}
                                checked={vendorSuperSwitch}
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "vendorSuperSwitch"
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("Vendor Admin")} :</label>
                              <Switch
                                name="vendorAdminSwitch"
                                checkedChildren={t("Yes")}
                                unCheckedChildren={t("No")}
                                checked={vendorAdminSwitch}
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "vendorAdminSwitch"
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("Vendor User")} :</label>
                              <Switch
                                name="vendorUserSwitch"
                                checkedChildren={t("Yes")}
                                unCheckedChildren={t("No")}
                                checked={vendorUserSwitch}
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "vendorUserSwitch"
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("Vendor-Diamond Super")} :</label>
                              <Switch
                                name="vendorDiamondSuperSwitch"
                                checkedChildren={t("Yes")}
                                unCheckedChildren={t("No")}
                                checked={vendorDiamondSuperSwitch}
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "vendorDiamondSuperSwitch"
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("Vendor-Diamond Admin")} :</label>
                              <Switch
                                name="VendorDiamondAdminSwitch"
                                checkedChildren={t("Yes")}
                                unCheckedChildren={t("No")}
                                checked={VendorDiamondAdminSwitch}
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "VendorDiamondAdminSwitch"
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("Vendor-Diamond User")} :</label>
                              <Switch
                                name="VendorDiamondUserSwitch"
                                checkedChildren={t("Yes")}
                                unCheckedChildren={t("No")}
                                checked={VendorDiamondUserSwitch}
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "VendorDiamondUserSwitch"
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("Vendor-Gemstone Super")} :</label>
                              <Switch
                                name="vendorGemstoneSuperSwitch"
                                checkedChildren={t("Yes")}
                                unCheckedChildren={t("No")}
                                checked={vendorGemstoneSuperSwitch}
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "vendorGemstoneSuperSwitch"
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("Vendor-Gemstone Admin")} :</label>
                              <Switch
                                name="VendorGemstoneAdminSwitch"
                                checkedChildren={t("Yes")}
                                unCheckedChildren={t("No")}
                                checked={VendorGemstoneAdminSwitch}
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "VendorGemstoneAdminSwitch"
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("Vendor-Gemstone User")} :</label>
                              <Switch
                                name="VendorGemstoneUserSwitch"
                                checkedChildren={t("Yes")}
                                unCheckedChildren={t("No")}
                                checked={VendorGemstoneUserSwitch}
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "VendorGemstoneUserSwitch"
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("Retailer Super")} :</label>
                              <Switch
                                name="retailerSuperSwitch"
                                checkedChildren={t("Yes")}
                                unCheckedChildren={t("No")}
                                checked={retailerSuperSwitch}
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "retailerSuperSwitch"
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("Retailer Admin")} :</label>
                              <Switch
                                name="retailerAdminSwitch"
                                checkedChildren={t("Yes")}
                                unCheckedChildren={t("No")}
                                checked={retailerAdminSwitch}
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "retailerAdminSwitch"
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("Retailer User")} :</label>
                              <Switch
                                name="retailerUserSwitch"
                                checkedChildren={t("Yes")}
                                unCheckedChildren={t("No")}
                                checked={retailerUserSwitch}
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "retailerUserSwitch"
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("Admin Admin")} :</label>
                              <Switch
                                name="adminAdminSwitch"
                                checkedChildren={t("Yes")}
                                unCheckedChildren={t("No")}
                                checked={adminAdminSwitch}
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "adminAdminSwitch"
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("Admin Super")} :</label>
                              <Switch
                                name="adminSuperSwitch"
                                checkedChildren={t("Yes")}
                                unCheckedChildren={t("No")}
                                checked={adminSuperSwitch}
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "adminSuperSwitch"
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="input__block">
                              <label> {t("Admin User")} :</label>
                              <Switch
                                name="adminUserSwitch"
                                checkedChildren={t("Yes")}
                                unCheckedChildren={t("No")}
                                checked={adminUserSwitch}
                                onChange={(e) =>
                                  handleOnChange(e, "select", "adminUserSwitch")
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>
              <Modal
                title={t("Delete")}
                className="modalconsupld__section"
                centered
                visible={visible3}
                onOk={() => setVisible3(false)}
                onCancel={() => setVisible3(false)}
                width={400}
                footer={[
                  <Button key="back" onClick={handleDelCancel}>
                    {t("Cancel")}
                  </Button>,
                  <Button
                    key="submit"
                    type="primary"
                    onClick={handleDeleteTierDetails}
                  >
                    {t("Delete")}
                  </Button>,
                ]}
              >
                <div className="col-lg-12">
                  <div className="modal__body">
                    <div className="col-lg-12">
                      <div className="form__fields border-0 p-0">
                        <div className="row">
                          <div className="col-lg-12 text-center">
                            <p>{t("Are you sure you want to delete")}</p>
                            <h5>{t("THIS CAN NOT BE UNDONE")}</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>

              <Modal
                title={t("Create Tier")}
                className="modalconsupld__section"
                centered
                visible={tierVisible}
                onCancel={handleModalTierCancel}
                width={400}
                footer={[
                  <Button key="back" onClick={handleModalTierCancel}>
                    {t("Cancel")}
                  </Button>,
                  <Button key="submit" type="primary" onClick={handleTierSave}>
                    {t("Save")}
                  </Button>,
                ]}
              >
                <div className="col-lg-12">
                  <div className="modal__body">
                    <div className="col-lg-12">
                      <div className="form__fields border-0 p-0">
                        <div className="row">
                          <div className="input__block">
                            <label>
                              {t("Tier Type")} : <span>*</span>
                            </label>
                            <Select
                              name="tierPageNameType"
                              value={
                                tierEntry.tierPageNameType
                                  ? tierEntry.tierPageNameType
                                  : null
                              }
                              showSearch
                              placeholder={t(" Select Tier Type")}
                              optionFilterProp="children"
                              onChange={(e) =>
                                handleInputChange(
                                  e,
                                  "select",
                                  "tierPageNameType"
                                )
                              }
                              className={
                                tiervalidations.tierPageNameTypeVal
                                  ? "border__red"
                                  : "border__grey"
                              }
                            >
                              <Option value="FirstTier">{t("Tier One")}</Option>
                              <Option value="SecondTier">
                                {t("Tier Two")}
                              </Option>
                            </Select>
                            <div>
                              {tiervalidations.tierPageNameTypeVal && (
                                <p className="error-color-red">
                                  {tiervalidations.tierPageNameTypeVal}
                                </p>
                              )}
                            </div>
                          </div>
                          {tierEntry.tierPageNameType == "SecondTier" ? (
                            <div className="col-lg-12">
                              <div className="input__block">
                                <label>
                                  {t("Select 1 Tier PageName")}
                                  <span className="mandatory">*</span>
                                </label>
                                <Select
                                  value={
                                    tierEntry.firstTierDep
                                      ? tierEntry.firstTierDep
                                      : null
                                  }
                                  name="firstTierDep"
                                  onChange={(e) =>
                                    handleInputChange(
                                      e,
                                      "select",
                                      "firstTierDep"
                                    )
                                  }
                                  placeholder={t("Select Type")}
                                  showSearch
                                  optionFilterProp="children"
                                  className={
                                    tiervalidations.firstTierDepVal
                                      ? "border__red"
                                      : "border__grey"
                                  }
                                >
                                  <Option value=""> {t("Select Type")} </Option>
                                  {tierOneList &&
                                    tierOneList.map((item) => {
                                      return (
                                        <Option key={item?.id} value={item.id}>
                                          {item.value}
                                        </Option>
                                      );
                                    })}
                                </Select>

                                <div>
                                  {tiervalidations.firstTierDepVal && (
                                    <p className="error-color-red">
                                      {tiervalidations.firstTierDepVal}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="col-lg-12">
                            <div className="input__block">
                              <label>
                                {t("Enter Tier Name")} : <span>*</span>
                              </label>
                              <input
                                name="tierPageNameValue"
                                value={
                                  tierEntry.tierPageNameValue
                                    ? tierEntry.tierPageNameValue
                                    : ""
                                }
                                onChange={handleInputChange}
                                type="text"
                                placeholder={t("Enter Tier Name")}
                                className={
                                  tiervalidations.tierPageNameValueVal &&
                                  "border__red"
                                }
                              />
                              <div>
                                {tiervalidations.tierPageNameValueVal && (
                                  <p className="error-color-red">
                                    {tiervalidations.tierPageNameValueVal}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Permissions;
